"use strict";

angular
    .module(ApplicationConfiguration.applicationModuleName)
    .controller(
        "dashboardColorsCtrl",
        function (
            $scope,
            $sessionStorage,
            ColorRequest,
            status,
            settings,
            states, managers,
            $localStorage,
            $state,
            commercial, operational, designers, segmentation
        ) {
            var vm = this;
            vm.settings = settings;

            vm.isDesigner = function () { return vm.settings.isColorsUserGroupByName('Designer'); };
            vm.isVendedor = function () { return vm.settings.isColorsUserGroupByName('VendedorBalcao'); };
            vm.isControleQualidade = function () { return vm.settings.isColorsUserGroupByName('ControleQualidade'); };
            vm.isGerenteNacional = function () { return vm.settings.isColorsUserGroupByName('GerenteNacional'); };
            vm.isGerenteRegional = function () { return vm.settings.isColorsUserGroupByName('GerenteRegional'); };

            angular.extend($scope.$parent.vm, {
                title: 'Dashboard',
                insertUrl: null,
            });

            if (!$localStorage || !$localStorage.groups || !$localStorage.groups.length) {
                settings.signOut();
                $state.go("login");
            }

            vm.status = status;
            vm.model = null;
            vm.states = states;
            vm.managers = managers;
            vm.groups = window.enumerators.enumGroupsColorsRequests;


            //collapses
            vm.filterCollapse = true;
            vm.dashCollapse = true;


            vm.chartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                events: true,
                tooltips: {
                    enabled: false
                },
                layout: {
                    padding: {
                        top: 20, // Adiciona 20 pixels de padding no topo
                    }
                },
                animation: {
                    duration: 500,
                    onComplete: function () {
                        var chartInstance = this.chart,
                            ctx = chartInstance.ctx;
                        ctx.font = Chart.helpers.fontString(10, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                        ctx.textAlign = 'end';
                        ctx.textBaseline = 'alphabetic';
                        ctx.fillStyle = 'black'; // Define a cor do texto aqui

                        var canvasElement = chartInstance.canvas;
                        var currencyFormat = canvasElement.getAttribute('data-currency-format') === "true"; // Lê o atributo personalizado

                        this.data.datasets.forEach(function (dataset, i) {
                            var meta = chartInstance.controller.getDatasetMeta(i);
                            meta.data.forEach(function (bar, index) {

                                var data = dataset.data[index];

                                if (currencyFormat) {
                                    // Format the value as currency here
                                    var formattedValue = Number(data).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                    ctx.fillText(formattedValue, bar._model.x, bar._model.y - 5);
                                } else {
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                }
                            });
                        });
                    }
                }
            };

            vm.getThisYearMonthsLabels = function () {
                // Array com todos os meses do ano em português
                const todosMeses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

                // Obter o mês atual (Janeiro é 0, Fevereiro é 1, etc.)
                const mesAtual = new Date().getMonth();

                // Gerar a lista de meses desde janeiro até o mês atual
                const mesesAteAgora = todosMeses.slice(0, mesAtual + 1);

                return mesesAteAgora;
            }
            vm.months = vm.getThisYearMonthsLabels();

            vm.showStatusList = function () {
                return vm.isDesigner() || vm.isVendedor() || vm.isControleQualidade()
            }

            vm.showRankings = function () {
                return vm.isGerenteRegional() || vm.isGerenteNacional() || vm.isControleQualidade();
            }

            vm.showManagmentDash = function () {
                return vm.isControleQualidade();
            }

            vm.showTotalCards = function () {
                return vm.isGerenteRegional() || vm.isGerenteNacional() || vm.isControleQualidade();
            }


            vm.fillDash = function (data) {
                if (!data) return;
                vm.dash = data;
                if (!vm.months) {
                    vm.months = vm.getThisYearMonthsLabels();
                }

                for (var index = 0; index < vm.dash.colorsList.length; index++) {
                    const e = vm.dash.colorsList[index];
                    e.position = `${index + 1}º`;
                }

                for (var index = 0; index < vm.dash.productsList.length; index++) {
                    const e = vm.dash.productsList[index];
                    e.position = `${index + 1}º`;
                }

                vm.data = vm.dash.statusList.map((x) => x.count);
                vm.labels = vm.dash.statusList.map((x) => x.name);
                vm.colorsChart = vm.dash.statusList.map((x) => x.color);

                vm.dash.countProjects = vm.dash.statusList.reduce((sum, x) => sum + (x.count || 0), 0);

                vm.barLineChartProjectsFill();
                vm.barLineChartSalesFill();
                vm.barLineChartFillProjectsGerentes();
                vm.barLineChartFillSalesGerentes();
                vm.barLineChartOtherProductsFill();
                vm.barLineChartTintingProductsFill();
            };

            vm.fillChartData = function (dataSource, chartType, colorBar, colorLine, currencyFormat) {
                if (!dataSource || !dataSource.series || !dataSource.series.length) {
                    return {};
                }
                const _customChartOption = Object.assign({}, vm.chartOptions);
                _customChartOption.events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
                _customChartOption.tooltips = {
                    enabled: true,
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function (ti) {
                            if (currencyFormat) {
                                return ' R$ ' + Number(ti.yLabel).toLocaleString('pt-BR',
                                    { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                            }
                            return ' ' + Number(ti.yLabel).toLocaleString('pt-BR');
                        }
                    }
                };

                const years = dataSource.series.map(year => parseInt(year));
                const maxYear = Math.max(...years);

                const generateLineColor = (index) => {
                    const baseColor = colorLine.split(', ').map(Number);
                    const increment = index * 40;
                    return [
                        (baseColor[0] + increment) % 256, // Red
                        (baseColor[1] + increment) % 256, // Green
                        (baseColor[2] + increment) % 256  // Blue
                    ].join(', ');
                };

                const formattedSeries = dataSource.series.map((yearStr, _index) => {
                    const year = parseInt(yearStr);

                    if (year === maxYear) {
                        // Ano atual: cor da barra
                        return {
                            name: yearStr,
                            color: `rgba(${colorBar}, 0.4)`,
                            border: `rgba(${colorBar}, 1)`
                        };
                    } else {
                        // Anos anteriores: cores únicas baseadas em colorLine
                        const lineColor = generateLineColor(_index);
                        return {
                            name: yearStr,
                            color: `rgba(${lineColor}, 1)`,
                            border: `rgba(${lineColor}, 1)`
                        };
                    }
                });

                const datasetOverride = dataSource.series.map((yearStr) => {
                    const year = parseInt(yearStr);
                    if (year === maxYear) {
                        return {
                            type: 'bar',
                            backgroundColor: `rgba(${colorBar}, 0.4)`,
                            borderColor: `rgba(${colorBar}, 1)`,
                            borderWidth: 1
                        };
                    } else {
                        // Dataset da linha (ano anterior)
                        const seriesEntry = formattedSeries.find(s => s.name === yearStr);
                        const lineColor = seriesEntry.border.replace('rgba(', '').replace(')', '').split(', ').slice(0, 3).join(', ');
                        return {
                            type: 'line',
                            fill: false,
                            clip: true,
                            borderColor: `rgba(${lineColor}, 1)`,
                            backgroundColor: `rgba(${lineColor}, 0.2)`,
                            pointBorderColor: `rgba(${lineColor}, 1)`,
                            pointBackgroundColor: '#fff',
                            pointHoverBackgroundColor: `rgba(${lineColor}, 1)`,
                            pointHoverBorderColor: `rgba(${lineColor}, 1)`,
                            yAxisID: 'y-axis-2'
                        };
                    }
                });

                _customChartOption.scales = {
                    yAxes: [
                        {
                            id: 'y-axis-2',
                            type: 'linear',
                            position: 'right',
                            gridLines: {
                                drawOnArea: false
                            },
                            ticks: {
                                autoSkip: true,
                                fontSize: 10,
                                padding: 20,
                                maxTicksLimit: 10,
                                beginAtZero: true,
                                callback: function (value) {
                                    if (currencyFormat) {
                                        return 'R$ ' + Number(value).toLocaleString('pt-BR');
                                    } else {
                                        return value;
                                    }
                                }
                            }
                        },
                        {
                            id: 'y-axis-1',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                autoSkip: true,
                                fontSize: 10,
                                padding: 50,
                                maxTicksLimit: 10,
                                beginAtZero: true,
                                callback: function (value) {
                                    return "";
                                }
                            }
                        }
                    ],
                };
                _customChartOption.animation = { duration: 500 };

                return {
                    labels: dataSource.labels,
                    series: dataSource.series,
                    data: dataSource.data,
                    legend: formattedSeries,
                    datasetOverride: datasetOverride,
                    options: _customChartOption
                };
            };

            vm.barLineChartProjectsFill = function () {
                vm.chartProjectsData = vm.fillChartData(
                    vm.dash.projectsEvolutionWithLastYearChart,
                    'barLine',
                    '183, 18, 52',  // Cor do Bar
                    '0, 103, 178',   // Cor da Line
                    false
                );
            };

            vm.barLineChartSalesFill = function () {
                vm.chartSalesData = vm.fillChartData(
                    vm.dash.salesTotalEvolutionWithLastYearChart,
                    'barLine',
                    '0, 103, 178',  // Cor do Bar
                    '183, 18, 52',   // Cor da Line
                    true
                );
            };

            vm.barLineChartOtherProductsFill = function () {
                vm.chartOtherProductsData = vm.fillChartData(
                    vm.dash.salesOthersProductsEvolutionWithLastYearChart,
                    'barLine',
                    '239, 108, 0',  // Cor do Bar
                    '38, 166, 154',   // Cor da Line
                    true
                );
            };

            vm.barLineChartTintingProductsFill = function () {
                vm.chartTintingProductsData = vm.fillChartData(
                    vm.dash.salesTintingProductsEvolutionWithLastYearChart,
                    'barLine',
                    '38, 166, 154',  // Cor do Bar
                    '239, 108, 0',   // Cor da Line
                    true
                );
            };

            vm.findNearestIndexInChartGerentes = function (selectedMonth, labels) {
                if (!selectedMonth || !labels) {
                    return 1;
                }

                // Tenta encontrar o índice do mês selecionado em vm.labels
                var labelIndex = labels.indexOf(selectedMonth);

                // Se o índice não for encontrado, retorna o último índice de vm.labels
                if (labelIndex === -1) {
                    labelIndex = labels.length - 1;
                }

                return labelIndex;
            }

            vm.fillManagerChart = function (dashSource) {
                let chartData = {};
                const dateNow = new Date();
                let currentDate = dateNow.getFullYear() + ' - ' +
                    dateNow.toLocaleString('pt-BR', { month: 'short' })
                        .toLowerCase()
                        .replace('.', '');

                const selectedMonth = vm.months.find(function (month) { return month === currentDate }) ? currentDate : dashSource.labels[0];

                chartData.labels = dashSource.series;
                chartData.originalData = dashSource.data;
                chartData.originalLabels = dashSource.labels;
                chartData.selectedMonth = selectedMonth; // Mês atual
                chartData.options = vm.chartOptions;

                return chartData;
            };

            vm.barLineChartFillProjectsGerentes = function () {
                if (vm.dash.projectsEvolutionByManagerChart) {
                    vm.chartProjectsGerentesData = {};
                    vm.chartProjectsGerentesData = vm.fillManagerChart(vm.dash.projectsEvolutionByManagerChart);
                    vm.updateProjectsManagerChart();
                }
            };

            vm.barLineChartFillSalesGerentes = function () {
                if (vm.dash.salesEvolutionByManagerChart) {
                    vm.chartSalesGerentesData = {};
                    vm.chartSalesGerentesData = vm.fillManagerChart(vm.dash.salesEvolutionByManagerChart);
                    vm.chartSalesGerentesData.options = {
                        ...vm.chartSalesGerentesData.options, scales: {
                            yAxes: [{
                                ticks: {
                                    callback: function (value, index, values) {
                                        return 'R$ ' + value.toLocaleString('pt-BR');
                                    }
                                }
                            }]
                        }
                    }
                    vm.updateSalesManagerChart();
                }
            };

            vm.updateManagerChart = function (chartData) {
                if (chartData && chartData.originalData) {
                    const _index = vm.findNearestIndexInChartGerentes(chartData?.selectedMonth, chartData?.originalLabels);
                    chartData.data = chartData.originalData.map(s => s[_index]);
                }
            };

            vm.updateProjectsManagerChart = function () {
                vm.updateManagerChart(vm.chartProjectsGerentesData);
            };

            vm.updateSalesManagerChart = function () {
                vm.updateManagerChart(vm.chartSalesGerentesData);
            };

            vm.refresh = function (filter) {
                var _filter = filter || $sessionStorage.colorsRequestsContextFilter;
                var filterCustomer = $sessionStorage.colorsRequestsContextFilter_Customer || null;


                if (!_filter) {
                    var todayDate = new Date(Date.now());
                    var firstDayOfTodayYear = new Date(todayDate.getFullYear(), 0, 1);
                    _filter = {
                        startsOn: firstDayOfTodayYear,
                        endsOn: todayDate,
                        expired: false,
                    };
                    $sessionStorage.colorsRequestsContextFilter = _filter;
                }

                _filter.customerId = null;
                if (filterCustomer) _filter.customerId = filterCustomer.key;

                ColorRequest.dash(_filter).$promise.then(function (data) {
                    vm.model = data;
                    vm.fillDash(vm.model);
                });
            };

            vm.updateFilters = function (filter) {
                if (filter) $sessionStorage.colorsRequestsContextFilter = filter;
                vm.refresh(filter);
                vm.loadKpis(filter);
            };

            // ─── SEÇÕES COLAPSÁVEIS DOS NOVOS KPIs ──────────────────────────
            vm.comercialCollapse  = true;
            vm.operacionalCollapse = true;
            vm.designerCollapse   = true;
            vm.segmentacaoCollapse = true;

            // ─── OPÇÕES DE GRÁFICO PARA OS KPIs MOCKADOS ────────────────────
            var _kpiBase = {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: false },
                tooltips: { enabled: true, mode: 'index', intersect: false },
                scales: {
                    yAxes: [{ ticks: { beginAtZero: true, fontSize: 10 }, gridLines: { color: 'rgba(0,0,0,0.04)' } }],
                    xAxes: [{ ticks: { fontSize: 10 } }]
                }
            };

            function _kpiOpts(format) {
                var opts = angular.copy(_kpiBase);
                if (!format) return opts;
                var fmtVal = function (v) {
                    if (format === 'currency')
                        return 'R$ ' + Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    if (format === 'percent')
                        return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%';
                    if (format === 'days')
                        return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' dias';
                    return Number(v).toLocaleString('pt-BR');
                };
                opts.tooltips.callbacks = { label: function (ti) { return ' ' + fmtVal(ti.yLabel); } };
                opts.scales.yAxes[0].ticks.callback = function (v) {
                    if (format === 'currency') {
                        if (v >= 1000000) return 'R$ ' + (v / 1000000).toFixed(1).replace('.', ',') + 'M';
                        if (v >= 1000)    return 'R$ ' + (v / 1000).toFixed(0) + 'K';
                        return 'R$ ' + Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
                    }
                    if (format === 'percent') return Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + '%';
                    if (format === 'days')    return Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + 'd';
                    return v;
                };
                return opts;
            }
            vm.kpiLineOptions   = angular.copy(_kpiBase);
            vm.kpiMonetaryOpts  = _kpiOpts('currency');
            vm.kpiPercentOpts   = _kpiOpts('percent');
            vm.kpiDaysOpts      = _kpiOpts('days');
            vm.kpiBarOptions     = angular.copy(_kpiBase);
            vm.kpiStackedOptions = angular.extend(angular.copy(_kpiBase), {
                scales: {
                    yAxes: [{ stacked: true, ticks: { beginAtZero: true, fontSize: 10, max: 100 }, gridLines: { color: 'rgba(0,0,0,0.04)' } }],
                    xAxes: [{ stacked: true, ticks: { fontSize: 10 } }]
                }
            });
            vm.kpiStackedAbsOptions = angular.extend(angular.copy(_kpiBase), {
                scales: {
                    yAxes: [{ stacked: true, ticks: { beginAtZero: true, fontSize: 10 }, gridLines: { color: 'rgba(0,0,0,0.04)' } }],
                    xAxes: [{ stacked: true, ticks: { fontSize: 10 } }]
                }
            });

            var _meses = ["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"];

            // ─── KPI rendering helpers ──────────────────────────────────────
            // Multi-series colour palette (designers / multi-line charts)
            var _dc = ['183,18,52','24,95,165','29,110,94','245,124,0','95,39,205','0,150,136','255,87,34','63,81,181'];

            // Shifts an "r,g,b" base colour so each prior-year line is visually distinct.
            function _shade(rgb, index) {
                var base = rgb.split(',').map(Number);
                var inc = index * 45;
                return [(base[0] + inc) % 256, (base[1] + inc) % 256, (base[2] + inc) % 256].join(',');
            }

            // Converts an API ChartSeries (labels=months, series=years, data=[][])
            // into the angular-chart.js shape: current year as bars, prior years as lines.
            function _evoChart(chart, barRgb) {
                chart = chart || {};
                var labels = chart.labels || [];
                var series = chart.series || [];
                var data = chart.data || [];
                if (!series.length) {
                    return { data: [], labels: [], series: [], colors: [], datasetOverride: [] };
                }
                var maxYear = Math.max.apply(null, series.map(function (y) { return parseInt(y, 10); }));
                var colors = [];
                var datasetOverride = series.map(function (yStr, i) {
                    if (parseInt(yStr, 10) === maxYear) {
                        colors.push('rgba(' + barRgb + ',0.5)');
                        return { type: 'bar', backgroundColor: 'rgba(' + barRgb + ',0.5)', borderColor: 'rgba(' + barRgb + ',1)', borderWidth: 1 };
                    }
                    var shade = _shade(barRgb, i + 1);
                    colors.push('rgba(' + shade + ',1)');
                    return {
                        type: 'line', fill: false, borderWidth: 2,
                        borderColor: 'rgba(' + shade + ',1)', backgroundColor: 'rgba(' + shade + ',0.2)',
                        pointBackgroundColor: '#fff', pointBorderColor: 'rgba(' + shade + ',1)'
                    };
                });
                return { data: data, labels: labels, series: series, colors: colors, datasetOverride: datasetOverride };
            }

            // Converts an API ChartSeries with series = names (e.g. designers) into a multi-line chart.
            function _multiLineChart(chart) {
                chart = chart || {};
                var series = chart.series || [];
                if (!series.length) {
                    return { data: [], labels: [], series: [], colors: [], datasetOverride: [] };
                }
                var colors = series.map(function (_, i) { return 'rgba(' + _dc[i % _dc.length] + ',1)'; });
                var datasetOverride = series.map(function () { return { type: 'line', fill: false, borderWidth: 2 }; });
                return { data: chart.data || [], labels: chart.labels || [], series: series, colors: colors, datasetOverride: datasetOverride };
            }

            // Reshapes a ByName chart (series=designer names, labels="yyyy - mmm") for one designer into evo format.
            function _designerEvoChart(byNameChart, designerName, barRgb) {
                var series    = (byNameChart || {}).series || [];
                var allLabels = (byNameChart || {}).labels || [];
                var allData   = (byNameChart || {}).data   || [];
                var designerIdx = series.indexOf(designerName);
                if (!series.length || designerIdx < 0)
                    return { data: [], labels: [], series: [], colors: [], datasetOverride: [] };

                var designerData = allData[designerIdx] || [];
                var yearOf  = allLabels.map(function (l) { return l.substring(0, 4); });
                var monthOf = allLabels.map(function (l) { return l.substring(7); });
                var _MONTH_ORDER = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
                var uniqueYears  = yearOf.filter(function (y, i, a)  { return a.indexOf(y) === i; }).sort();
                var uniqueMonths = monthOf.filter(function (m, i, a) { return a.indexOf(m) === i; })
                    .sort(function (a, b) { return _MONTH_ORDER.indexOf(a) - _MONTH_ORDER.indexOf(b); });

                var maxYear = Math.max.apply(null, uniqueYears.map(Number));
                var dataMatrix = uniqueYears.map(function (year) {
                    return uniqueMonths.map(function (month) {
                        var idx = allLabels.indexOf(year + ' - ' + month);
                        return idx >= 0 ? (designerData[idx] || 0) : 0;
                    });
                });

                var colors = [];
                var datasetOverride = uniqueYears.map(function (yStr, i) {
                    if (parseInt(yStr) === maxYear) {
                        colors.push('rgba(' + barRgb + ',0.5)');
                        return { type: 'bar', backgroundColor: 'rgba(' + barRgb + ',0.5)',
                            borderColor: 'rgba(' + barRgb + ',1)', borderWidth: 1 };
                    }
                    var shade = _shade(barRgb, i + 1);
                    colors.push('rgba(' + shade + ',1)');
                    return { type: 'line', fill: false, borderWidth: 2,
                        borderColor: 'rgba(' + shade + ',1)', backgroundColor: 'rgba(' + shade + ',0.2)',
                        pointBackgroundColor: '#fff', pointBorderColor: 'rgba(' + shade + ',1)' };
                });
                return { data: dataMatrix, labels: uniqueMonths, series: uniqueYears, colors: colors, datasetOverride: datasetOverride };
            }

            function _ranking(list) {
                return (list || []).map(function (r, i) {
                    return { position: (i + 1) + 'º', name: r.name, value: r.totalValue };
                });
            }

            function _pct(part, whole) {
                if (!whole) return 0;
                return Math.round((part / whole) * 1000) / 10;
            }

            // ─── Per-section appliers (each fed by its own endpoint) ────────
            vm.kpis = vm.kpis || {};

            vm.applyCommercial = function (comm) {
                comm = comm || {};
                vm.kpis.kpi01 = angular.extend({ periodo: comm.kpi01ConversionRate || 0 }, _evoChart(comm.kpi01Chart, '183,18,52'));
                vm.kpis.kpi02 = angular.extend({ periodo: comm.kpi02AvgTicket || 0 }, _evoChart(comm.kpi02Chart, '183,18,52'));
                vm.kpis.kpi03 = {
                    percentTinting: comm.kpi03PercentTinting || 0,
                    percentOthers: comm.kpi03PercentOthers || 0,
                    tinting: _evoChart(comm.kpi03TintingChart, '183,18,52'),
                    others: _evoChart(comm.kpi03OthersChart, '24,95,165')
                };
                vm.kpis.kpi04 = { ranking: _ranking(comm.kpi04Ranking) };
            };

            vm.applyOperational = function (oper) {
                oper = oper || {};
                vm.kpis.kpi06 = angular.extend({ atual: oper.kpi06OverdueCount || 0 }, _evoChart(oper.kpi06Chart, '211,47,47'));
                vm.kpis.kpi07 = {
                    labels: (oper.kpi07Stages || []).map(function (s) { return s.stageName; }),
                    data: [(oper.kpi07Stages || []).map(function (s) { return s.avgDays; })],
                    series: ['Tempo Médio (dias)'],
                    colors: ['rgba(183,18,52,0.7)']
                };
                vm.kpis.kpi08 = angular.extend({ periodo: oper.kpi08ReworkRate || 0 }, _evoChart(oper.kpi08Chart, '245,124,0'));
                vm.kpis.kpi10 = angular.extend({ periodo: oper.kpi10AvgProcessingDays || 0 }, _evoChart(oper.kpi10Chart, '21,101,192'));
            };

            vm.applyDesigners = function (des) {
                des = des || {};
                vm.kpi12Raw = des.kpi12Chart || { series: [], labels: [], data: [] };
                vm.kpi21Raw = des.kpi21Chart || { series: [], labels: [], data: [] };
                vm.kpi12Designers = vm.kpi12Raw.series || [];
                vm.kpi21Designers = vm.kpi21Raw.series || [];
                vm.kpi12SelectedDesigner = vm.kpi12Designers[0] || null;
                vm.kpi21SelectedDesigner = vm.kpi21Designers[0] || null;

                if (!vm.kpis.kpi11) {
                    vm.kpis.kpi11 = { labels: [], data: [[]], series: ['Projetos Ativos'], colors: ['rgba(183,18,52,0.7)'] };
                }
                vm.kpis.kpi12 = _designerEvoChart(vm.kpi12Raw, vm.kpi12SelectedDesigner, '183,18,52');
                vm.kpis.kpi21 = _designerEvoChart(vm.kpi21Raw, vm.kpi21SelectedDesigner, '21,101,192');
                vm.kpis.kpi22 = { ranking: _ranking(des.kpi22Ranking) };
            };

            vm.selectKpi12Designer = function (name) {
                vm.kpi12SelectedDesigner = name;
                vm.kpis.kpi12 = _designerEvoChart(vm.kpi12Raw, name, '183,18,52');
            };
            vm.selectKpi21Designer = function (name) {
                vm.kpi21SelectedDesigner = name;
                vm.kpis.kpi21 = _designerEvoChart(vm.kpi21Raw, name, '21,101,192');
            };

            vm.loadKpi11 = function () {
                ColorRequest.dashboardDesigners({}).$promise
                    .then(function (d) {
                        vm.kpis.kpi11 = {
                            labels: (d.kpi11Workload || []).map(function (x) { return x.designerName; }),
                            data: [(d.kpi11Workload || []).map(function (x) { return x.activeProjects; })],
                            series: ['Projetos Ativos'],
                            colors: ['rgba(183,18,52,0.7)']
                        };
                    })
                    .catch(function () {
                        vm.kpis.kpi11 = { labels: [], data: [[]], series: ['Projetos Ativos'], colors: ['rgba(183,18,52,0.7)'] };
                    });
            };

            vm.applySegmentation = function (seg) {
                seg = seg || {};
                var k14Total = (seg.kpi14TotalInterior || 0) + (seg.kpi14TotalExterior || 0);
                var k15Total = (seg.kpi15TotalResidential || 0) + (seg.kpi15TotalCommercial || 0);
                vm.kpis.kpi14 = {
                    percentInterior: _pct(seg.kpi14TotalInterior || 0, k14Total),
                    percentExterior: _pct(seg.kpi14TotalExterior || 0, k14Total),
                    interior: _evoChart(seg.kpi14InteriorChart, '183,18,52'),
                    exterior: _evoChart(seg.kpi14ExteriorChart, '24,95,165')
                };
                vm.kpis.kpi15 = {
                    percentResidencial: _pct(seg.kpi15TotalResidential || 0, k15Total),
                    percentComercial: _pct(seg.kpi15TotalCommercial || 0, k15Total),
                    residential: _evoChart(seg.kpi15ResidentialChart, '24,95,165'),
                    commercial: _evoChart(seg.kpi15CommercialChart, '183,18,52')
                };
                vm.kpis.kpi16 = {
                    tabela: (seg.kpi16ByState || []).map(function (s) {
                        return { uf: s.uf, projetos: s.projects, vendas: s.totalSales, conversao: s.conversionRate };
                    })
                };
                vm.kpis.kpi17 = {
                    revenda: _evoChart(seg.kpi17RevendaChart, '24,95,165'),
                    loja: _evoChart(seg.kpi17LojaChart, '183,18,52')
                };
                vm.kpis.kpi19 = {
                    totalNovos: seg.kpi19TotalNew || 0,
                    totalRecorrentes: seg.kpi19TotalRecurring || 0,
                    novos: _evoChart(seg.kpi19NewChart, '24,95,165'),
                    recorrentes: _evoChart(seg.kpi19RecurringChart, '183,18,52')
                };
            };

            // Builds the clean query param set sent to every dashboard endpoint.
            // Carries the full filter (incl. store/customer); never leaks a "page" param.
            vm.buildKpiParams = function (filter) {
                var f = filter || $sessionStorage.colorsRequestsContextFilter || {};
                var fc = $sessionStorage.colorsRequestsContextFilter_Customer || null;
                return {
                    startDate: f.startsOn || null,
                    endDate: f.endsOn || null,
                    statusId: f.statusId || null,
                    stateId: f.stateId || null,
                    designerName: f.designerName || null,
                    managerId: f.managerId || null,
                    customerId: (f.customerId != null ? f.customerId : (fc ? fc.key : null))
                };
            };

            // Loads the 4 endpoints independently so each section clears its own loader.
            vm.loadKpis = function (filter) {
                var params = vm.buildKpiParams(filter);

                vm.loadingComercial = true;
                ColorRequest.dashboardCommercial(params).$promise
                    .then(function (d) { vm.applyCommercial(d); })
                    .catch(function () { vm.applyCommercial({}); })
                    .finally(function () { vm.loadingComercial = false; });

                vm.loadingOperacional = true;
                ColorRequest.dashboardOperational(params).$promise
                    .then(function (d) { vm.applyOperational(d); })
                    .catch(function () { vm.applyOperational({}); })
                    .finally(function () { vm.loadingOperacional = false; });

                vm.loadingDesigner = true;
                ColorRequest.dashboardDesigners(params).$promise
                    .then(function (d) { vm.applyDesigners(d); })
                    .catch(function () { vm.applyDesigners({}); })
                    .finally(function () { vm.loadingDesigner = false; });

                vm.loadingSegmentacao = true;
                ColorRequest.dashboardSegmentation(params).$promise
                    .then(function (d) { vm.applySegmentation(d); })
                    .catch(function () { vm.applySegmentation({}); })
                    .finally(function () { vm.loadingSegmentacao = false; });
            };

            // Initial render from route-resolved data (last 12 months, no extra round-trip).
            vm.applyCommercial(commercial);
            vm.applyOperational(operational);
            vm.applyDesigners(designers);
            vm.applySegmentation(segmentation);
            vm.loadKpi11();

        }
    );
